export const AVANCE_LANDING_PATHS = Object.freeze({
  cinematic: '/doubler-son-tarif',
  professional: '/avace-immediate-tool',
});

export const AVANCE_DEMAND_PREVIEW = Object.freeze({ amount: 160, columns: Object.freeze(['month', 'label', 'amount_ttc']) });

export const AVANCE_LANDING_LINKS = Object.freeze({
  conditions: 'https://www.urssaf.fr/accueil/services/services-particuliers/service-avance-immediate.html',
  company: 'https://formalites.entreprises.gouv.fr',
  sap: 'https://nova.entreprises.gouv.fr',
  api: 'https://api.gouv.fr/les-api/api-tiers-de-prestation',
  companyGuide: '/blog/declarer-revenus-cours-particuliers',
  serviceGuide: '/blog/avance-immediate-urssaf-cours-particuliers',
});

export const AVANCE_LANDING_MOTION = Object.freeze({
  heroBeats: [300, 2500, 4500, 5700, 7000],
  heroFinish: 7900, heroIdle: 9000, peck: 700, countdown: 900,
  professionalAppear: 1400, professionalSent: 2200, flowDuration: 9000,
  flowBeats: [0, 0.36, 0.66], quizPeck: 420, sceneOpen: 0.55, sceneReadLine: 0.5,
});
